import http from "../../services/http";

const getAllFormsApi = async () => {
  return await http("get", "v1/formularios_colaboradores/formularios/getAll");
};

const getAllActiveFormsApi = async () => {
  return await http("get", "v1/formularios_colaboradores/formularios/getAllActiveByProfile");
};

const getFormByIdApi = async (id) => {
  return await http("get", `v1/formularios_colaboradores/formularios/get/${id}`);
};

const createFormApi = async (data) => {
  return await http("post", "v1/formularios_colaboradores/formularios/create", data);
};

const updateFormApi = async (data) => {
  return await http("post", "v1/formularios_colaboradores/formularios/update", data);
};

const deleteFormApi = async (id) => {
  return await http("post", "v1/formularios_colaboradores/formularios/delete", { id: id });
};

export { getAllFormsApi, getFormByIdApi, createFormApi, updateFormApi, deleteFormApi, getAllActiveFormsApi };
